module.exports = __webpack_public_path__ + "img/diagramaC.619f58c0.svg";